// extracted by mini-css-extract-plugin
export default {"main":"index_main__zm7Hg","mainArea":"index_mainArea__Nvol2","isMobile":"index_isMobile__--5p2","operationArea":"index_operationArea__0c6JV"};